import Link from "next/link";

import classes from "./Cards.module.scss";
import {NOT_FOUND_IMAGE_URL} from "../../constants";
import type {Unit} from "../../graphql/types";
import MediaImage from "../MediaImage";

export interface UnitCardProps {
  unit: Partial<Unit>; // Unit to display in card
}

/**
 * Unit card
 */
export default function UnitCard({unit}: UnitCardProps) {
  const unitUrl = `/units/${unit?.slug}`;

  let unitName = unit.name || `Unnamed #${unit.id}`;
  unitName = `Camp site: ${unitName}`;

  return (
    <div className={classes.card}>
      <div className={classes.cardImageWrapper}>
        {unit.primaryMedia ? (
          <MediaImage className={classes.cardImage} media={unit.primaryMedia} />
        ) : (
          <img
            className={classes.cardImage}
            alt="No image"
            src={NOT_FOUND_IMAGE_URL}
          />
        )}
      </div>
      <div className={classes.cardTitle}>
        {unit.facility && (
          <div className="parent-header">
            {unit.facility.park && (
              <span>
                <Link
                  href={`/parks/${unit.facility.park.slug}`}
                  legacyBehavior
                  passHref>
                  <a title={unit.facility.park.name || ""}>
                    {unit.facility.park.name}
                  </a>
                </Link>
                {" / "}
              </span>
            )}
            <Link
              href={`/facilities/${unit.facility.slug}`}
              legacyBehavior
              passHref>
              <a title={unit.facility.name || ""}>{unit.facility.name}</a>
            </Link>
          </div>
        )}
        <Link href={unitUrl} legacyBehavior passHref>
          <a title={unitName}>{unitName}</a>
        </Link>
      </div>
    </div>
  );
}
